module.exports = __webpack_public_path__ + "img/turkeySandwich.5ab816bf.png";